import { Dialog, Skeleton } from '@cobliteam/ui/components';

const VehicleDialogSkeleton = () => {
  return (
    <Dialog open onOpenChange={() => {}}>
      <Dialog.Content size='lg' className='max-w-4xl'>
        <Dialog.Header className='w-full'>
          <div className='flex w-full items-center justify-between gap-2 p-1'>
            <div className='flex items-start gap-2'>
              <Skeleton className='h-12 w-12 rounded-md' />
              <div className='flex flex-col gap-1'>
                <Skeleton className='h-6 w-32' />
                <Skeleton className='h-4 w-48' />
              </div>
            </div>
            <Skeleton className='h-8 w-8 rounded-md' />
          </div>
          <Dialog.Close />
        </Dialog.Header>

        <Dialog.Body className='flex max-h-[80vh] flex-col gap-6 overflow-y-auto p-6'>
          {/* Tags Skeleton */}
          <div className='flex w-full flex-row items-center gap-2'>
            <Skeleton className='h-8 w-8 rounded-md' />
            <Skeleton className='h-6 w-24 rounded-full' />
            <Skeleton className='h-6 w-24 rounded-full' />
          </div>

          {/* Details Grid Skeleton */}
          <div className='grid grid-cols-12 gap-2'>
            <div className='col-span-5 flex flex-col gap-2'>
              <div className='flex items-center gap-2'>
                <Skeleton className='h-4 w-4' />
                <Skeleton className='h-4 w-24' />
              </div>
              <div className='ml-5 flex flex-col gap-1'>
                <Skeleton className='h-4 w-32' />
                <Skeleton className='h-4 w-32' />
                <Skeleton className='h-4 w-32' />
              </div>
            </div>

            <div className='col-span-7 flex flex-col gap-2'>
              <div className='flex items-center gap-2'>
                <Skeleton className='h-4 w-4' />
                <Skeleton className='h-4 w-24' />
              </div>
              <div className='ml-5 flex flex-col gap-1'>
                <Skeleton className='h-4 w-40' />
                <Skeleton className='h-4 w-48' />
                <Skeleton className='h-4 w-36' />
              </div>
            </div>
          </div>

          {/* Cards Grid Skeleton */}
          <div className='grid grid-cols-2 gap-2'>
            <div className='flex flex-col gap-2'>
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className='flex h-16 w-full items-center gap-3 rounded-md border border-gray-3 p-3'>
                  <Skeleton className='h-10 w-10 rounded-md' />
                  <div className='flex flex-col gap-1'>
                    <Skeleton className='h-4 w-40' />
                    <Skeleton className='h-3 w-24' />
                  </div>
                </div>
              ))}
            </div>
            {/* Map Card Skeleton */}
            <div className='flex flex-col gap-2'>
              <div className='flex flex-row items-center justify-between'>
                <div className='flex flex-col gap-1'>
                  <Skeleton className='h-4 w-32' />
                  <Skeleton className='h-3 w-24' />
                </div>
                <Skeleton className='h-6 w-24' />
              </div>
              <Skeleton className='h-[200px] w-full rounded-sm' />
            </div>
          </div>

          {/* Banner Skeleton */}
          <Skeleton className='h-12 w-full rounded-md' />
        </Dialog.Body>
      </Dialog.Content>
    </Dialog>
  );
};

export default VehicleDialogSkeleton;
